import DecisioningServiceClient from '../components/admin/dashboard/decisioningServiceClient';
import FetchHelper from '../helpers/fetch_helper';
import Constants from '../helpers/constants';

import WindowHelper from '../helpers/window_helper';
import DecisioningHelper from '../helpers/decisioning_helper';

const DecisioningDispatcher = {
  async gotoDecisionList() {
    await this.dispatch({ type: 'fetchDecisionTable', data: {} });
    this.dispatch({ type: 'setRoute', data: '/admin/customers/decisions/' });
  },

  async goToDecisionDetails({ id, inNewTab }) {
    await this.dispatch({ type: 'clearDecisionData', data: {} });
    if (inNewTab) {
      const uwBaseUrl = `${window.location.protocol + '//' + window.location.host.replace(/switch/g, 'uw')}`;
      window.open(`${uwBaseUrl}/admin/customers/decisions/${id}`, '_blank').focus();
    } else {
      this.dispatch({ type: 'setRoute', data: `/admin/customers/decisions/${id}` });
    }
  },

  clearDecisions() {
    this.setStoreVal('decisioningTableData', null);
  },

  clearDecisionData() {
    this.setStoreVal('decisioningPageData', null);
    this.setStoreVal('decisioningPageSwitchInfo', null);
    this.setStoreVal('decisionNotesList', null);
  },

  async fetchDecisionTable(data) {
    let decisions = await new DecisioningServiceClient().getDecisions();
    this.setStoreVal('decisioningTableData', DecisioningHelper.parseDecisionTableData(decisions));
  },

  async fetchDecisionTableInactive(data) {
    let decisions = await new DecisioningServiceClient().getDecisionsInactive(data);
    this.setStoreVal('decisioningTableInactiveData', DecisioningHelper.parseDecisionTableData(decisions));
  },

  async fetchDecisionPage(data) {
    const decision = await new DecisioningServiceClient().getDecision(data.id);
    this.setStoreVal('decisioningPageData', DecisioningHelper.parseDecisionPageData(decision));
    return decision;
  },

  async fetchSwitchDataForUWDash({ customerId }) {
    try {
      const result = await new DecisioningServiceClient().getSwitchDataByCustomerId(customerId);
      this.setStoreVal('decisioningPageSwitchInfo', result);
      return result;
    } catch (e) {
      this.setStoreVal('decisioningPageSwitchInfo', { errorFindingInfo: true });
      return false;
    }
  },

  async fetchDecisionProcessDenialReasons({ id }) {
    return await new DecisioningServiceClient().getProcessDenialReasons(id);
  },

  async fetchDecisionUserByCustomer(data) {
    return await new DecisioningServiceClient().getUserByCustomerId(data);
  },

  async fetchDecisionUsers(data) {
    const users = await new DecisioningServiceClient().getUsers();
    const meifiedUsers = (users || [])
      // find "me" in the list of users and flag it
      .map((item) => {
        item.isMe =
          (item.userName || '').toLowerCase() ===
          (new DecisioningServiceClient().getCurrentUsername() || '').toLowerCase();
        return item;
      })
      // sort "me" first, then sort the rest by first name then last name
      .sort((a, b) => {
        return b.isMe - a.isMe || a.firstName.localeCompare(b.firstName) || a.lastName.localeCompare(b.lastName);
      });
    this.setStoreVal('decisioningPageUsers', meifiedUsers);
    return users;
  },

  async saveDecisionPage(data) {
    console.log(!!data.manualUWComplete ? 'SUBMITTING' : 'SAVING', data);
    try {
      await FetchHelper.fetchJson(`decisions/${data.id}`, {
        method: 'PUT',
        body: data,
      });
    } catch (error) {
      if (error.response && error.response.status === Constants.ERROR_CODE.FORBIDDEN) {
        this.dispatch({
          type: 'handleRequestError',
          data: { defaultErrorMessage: 'You do not have permission to save.' },
        });
      } else {
        // this.dispatch({
        //   type: "handleRequestError",
        //   data: {error, defaultErrorMessage: "Failed to save"}
        // });
      }
    }
  },

  async changeAssignment(data) {
    const decision = await new DecisioningServiceClient().changeOwner(data);
    this.setStoreVal('decisioningPageData', decision);
  },

  async reapply(data) {
    this.acquireLock('reapply');
    await new DecisioningServiceClient().reapply(data);

    // wait 5 seconds for bonita to update to submitted, then request an update explicitly
    window.setTimeout(async () => {
      await this.dispatch({ type: 'fetchDecisionPage', data });
      this.releaseLock('reapply');
    }, 5000);
  },

  async hardenCredit(data) {
    this.acquireLock('hardenCredit');
    await new DecisioningServiceClient().hardenCredit(data);

    // wait 5 seconds for bonita to update to submitted, then request an update explicitly
    window.setTimeout(async () => {
      await this.dispatch({ type: 'fetchDecisionPage', data });
      this.releaseLock('hardenCredit');
    }, 5000);
  },

  async fetchDecisionNotes(data) {
    const results = await new DecisioningServiceClient().fetchDecisionNotes(data);
    this.setStoreVal('decisionNotesList', results);
    return results;
  },

  async createDecisionNotes(data) {
    const results = await new DecisioningServiceClient().createDecisionNotes(data);
    this.setStoreVal('decisionNotesList', results);
    return results;
  },

  async deleteDecisionNote(data) {
    const results = await new DecisioningServiceClient().deleteDecisionNote(data);
    this.setStoreVal('decisionNotesList', results);
    return results;
  },

  async fetchFile(fileId) {
    let mockB64File = `I am not a PDF`;
    let blob = new Blob([mockB64File], { type: 'application/pdf' });
    let bytesPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve(blob);
      }, 1000);
    });
    WindowHelper.openFile(bytesPromise);
  },

  async fetchApplicantPII(data) {
    return await new DecisioningServiceClient().getApplicantPII(data.decisionId, data.applicantType);
  },
};

export default DecisioningDispatcher;
